import listing from "../listing";

export default function () {
  return {
    allBrands: {},
    auctionsByBrand: {},
    listingsByBrand: {},
    products: [],
    brandDetails: {},
    brands: [],
    storefronts: [],
    storefrontData: {},
    category_images: [],
    category_types: [],
    categories: [],
    subcategories: [],
    non_metrc_categories: [],
    inventory_filter_categories: [],
    trim_types: [],
    strain_types: [],
    ingredients: [],
    production_types: [],
    licenses: [],
    payment_methods: [],
    payment_terms: [],
    payment_statuses: [],
    grow_media: [],
    company: {
      name: "",
      ein: "",
      logo_url: "",
      status: {
        name: "",
      },
      created_on: "",
      addons_access: [],
      shared_stock_with: [],
      shared_stock_from: []
    },
    company_shipping_boxes: [],
    temp_shipping_boxes: [],
    company_contacts: [],
    users: [],
    location_names: [],
    location_pairs: {},
    inventory_category_types: [],
    isLoadingData: true,
    listings: [],
    auctions: [],
    auctionLastSynced: null,
    listingLastSynced: null,
    order_statuses: [],
    order_sources: [],
    order_types: [],
    productsByBrand: {},
    brandLoadingStates: {},
    lastBrandUpdate: null,
    availablePackageTags: {},
    productLines: [],
    metrcKeyStatus: {
      licenses: [],
      masterUser: null,
      userCheckedAt: null,
      masterUserCheckedAt: null,
      stale: false,
    },
    app_notifications: [],
  };
}
